module.exports = __webpack_public_path__ + "static/img/img_form_1_zh_cn.8d4e4fcd.png";